<template>
	<div class="mobile-nav">
		<ul class="mobile-menu card-info-pages-menu vertical menu accordion-menu" data-accordion-menu ref="langMenu">
			<li class="mobile-menu-item menu-item-language">
				<a href="#"><span class="menu-item-label">{{ $t('language') }}:</span><span class="menu-item-value">{{ $t('languageName') }}</span>
				</a>
				<ul class="menu vertical nested">
					<li class="language-item" v-for="lang in langs" :key="`lang-${lang}`" :value="lang">
						<a @click="switchLanguage(lang)">{{ $t('languageName', lang) }}</a>
					</li>
				</ul>
			</li>
			<li class="mobile-menu-item" v-for="page in pages" :key="`card-info-page-${page.id}`">
				<a @click="navigateToPage({ name: 'single-card-info', params: { uuid: page.id } })">
					{{ $t(`infopages.${page.type}`) }}
				</a>
			</li>
			<li class="mobile-menu-item" v-if="installOnIOS">
				<a @click="openIosInstallationHint">
					{{ $t('installOnIos') }}
				</a>
			</li>
			<li class="mobile-menu-item version-info">
				<span class="version-info">{{ $t('appVerision') }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
	import foundation from '@/mixins/foundation'

	export default{
		name: 'MobileNavigation',
		computed: {
			pages () {
				return this.$store.getters.getCurrentCardinfos.filter(page => page.type !== 'home')
			},
			newsCount () {
				return this.$store.getters.getCurrentNews.length
			},
			installOnIOS () {
				if (this.$store.state.browser && this.$store.state.browser.name && this.$store.state.browser.name == 'ios') {
					return true
				}

				return false
			}
		},
		data () {
			return {
				langs: ['de', 'en'] // 'it', 'sl'
			}
		},
		mixins: [foundation],
		methods: {
			closeOffCanvas(){
				if (this.$parent.$refs.offCanvas !== undefined) {
					$(this.$parent.$refs.offCanvas).foundation('close')
				}

				if(this.$refs.langMenu) {
					$(this.$refs.langMenu).foundation('hideAll');
				}
			},
			navigateToPage(routerConfig) {
				this.closeOffCanvas();
				this.$router.push(routerConfig)
			},
			switchLanguage(lang = 'de') {
				this.$i18n.locale = lang;
				this.$store.dispatch('updateLanguage', lang);
				this.closeOffCanvas();
			},
			openIosInstallationHint () {
				this.$eBus.$emit('show-ios-installation-hint')
			}
		},
		created () {
			if (this.pages.length <= 0) {
				this.$store.dispatch('fetchCardInfos', { lang: this.$store.state.language, season: this.$store.state.season })
			}
			if (this.newsCount <= 0) {
				this.$store.dispatch('fetchNews', { lang: this.$store.state.language, season: this.$store.state.season })	
			}
		}
	}
</script>

<style lang="scss" scoped>
	.mobile-nav{
		.card-info-pages-menu{
			.mobile-menu-item {
				text-align: left;
				font-weight: 700;

				border-top: 1px solid rgba($black, .1);
				
				&:last-child{
					border-bottom: 1px solid rgba($black, .1);
				}

				.menu-item-value{
					padding-left: .5rem;
					font-weight: normal;
				}

				a {
					padding: 1.5rem 1rem;
					color: $dark-gray;
				}

				&.menu-item-language{
					a{
						padding-bottom: 1rem;
					}
				}
				&.version-info {
					text-align: center;
					font-size: .85rem;
					font-weight: 100;
					color: #aaa;
					padding: 1rem;
				}
			}

			.language-item{
				padding: 0;
				font-weight: normal;

				&:last-child{
					a{
						padding-bottom: 1.5rem;
					}
				}

				a{
					padding: .5rem 1rem;
				}
			}
		}
	}
</style>